import { Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Delete } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface Props {
  disabled?: boolean
  onDeleteAction: () => void
}

const DeleteButton = ({ disabled, onDeleteAction }: Props) => {
  const [isTooltipOpen, toggleTooltip] = useToggle(false)

  return (
    <Box onMouseEnter={toggleTooltip(!disabled)} onMouseLeave={toggleTooltip(false)}>
      <Tooltip.Alt
        open={isTooltipOpen}
        attachment="top center"
        label={i18n.t('shift_management.actions.delete')}
      >
        <F0Button
          hideLabel
          icon={Delete}
          onClick={onDeleteAction}
          size="md"
          variant="outline"
          disabled={disabled}
        />
      </Tooltip.Alt>
    </Box>
  )
}

export default DeleteButton
